const getAccountTypeResponse = (response) => {
  return response?.accountTypes.map((accountType) => {
    return {
      id: accountType?.id,
      value: accountType?.name,
      label: accountType?.name,
    };
  });
};

export default getAccountTypeResponse;
